<ng-container *transloco="let t; prefix: 'dod-directory-filtering'">
  <accredible-text-input
    class="search-directory-filter"
    [placeholder]="t('placeholder')"
    [formControlRef]="searchControl"
    [dataCy]="'search-directory-filtering'"
    [icon]="searchControl.value ? 'close' : 'search'"
    [noError]="true"
    (iconClick)="clearSearchTerm()"
    (keyup)="keyUp($event)" />

  <accredible-multi-search-filter-menu
    class="skill-category-filter-desktop"
    [buttonText]="t('categories')"
    [buttonSize]="'normal'"
    [placeholder]="t('search_categories')"
    [options]="skillCategories()"
    [selectedOptions]="selectedSkillCategories()"
    [optionsLabelKey]="'name'"
    [optionsImgKey]="'image'"
    [usingStaticOptions]="true"
    [menuWidthEqualsButtonWidth]="false"
    (optionsChanged)="selectedSkillCategoriesChange($event)"
    (searchChanged)="searchCategory($event)">
  </accredible-multi-search-filter-menu>

  <button
    accredible-button-outline
    class="btn-skill-category-filter-mobile"
    color="natural"
    icon="chevron-right"
    iconSize="8px"
    (click)="openMobileSidenav()">
    <span>
      <accredible-icon
        [class.active-filters]="selectedSkillCategories().length > 0"
        [icon]="'filters'" />
      {{ t('filters') }}
    </span>
  </button>
</ng-container>
